var map = {
	"./algorithms.webp": 6809,
	"./algorithms_blur.webp": 8509,
	"./bookmeister.webp": 7269,
	"./bookmeister_blur.webp": 7164,
	"./mdnotes.webp": 8672,
	"./mdnotes_blur.webp": 1003,
	"./memorizeit.webp": 8866,
	"./memorizeit_blur.webp": 9235,
	"./northwind.webp": 2974,
	"./northwind_blur.webp": 706,
	"./pazdziorart.webp": 8980,
	"./pazdziorart_blur.webp": 7148,
	"./pomodoro.webp": 1113,
	"./pomodoro_blur.webp": 1470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6951;